import React from 'react';
import {AxiosError} from 'axios';
import {Action} from 'redux';
import {ThunkAction} from 'redux-thunk';
import {toast} from 'react-toastify';

import {IStore} from './interface';
import {finishLoadingAction, setErrorAction} from './status/actions';

import {GritxToast} from 'components/gritx-toast/GritxToast';
import {ToastKey} from 'components/gritx-toast/ToastKeyEnum';
import {getToastOption} from 'components/gritx-toast/ToastMessageConfig';

interface IErrorHandler {
  actionKey: string
  toastKey: ToastKey
  error: AxiosError,
  currentAction?: ThunkAction<void, IStore, unknown, Action>
}

export const errorHandler = ({
  actionKey,
  toastKey,
  error,
  currentAction
}: IErrorHandler): ThunkAction<void, IStore, unknown, Action> => (async (dispatch, getState) => {
  const {
    auth: {auth0Client},
    status: {errors}
  } = getState();
  const isAuthenticated = await auth0Client.isAuthenticated();

  function setError() {
    const option = getToastOption(toastKey);

    toast.error(<GritxToast options={{
      title: option?.title || actionKey,
      description: option?.description,
      showReloadButton: option.showReloadButton
    } }/>);

    dispatch(setErrorAction({
      key: actionKey,
      value: error
    }));
    dispatch(finishLoadingAction(actionKey));
  }

  setError();

  if (error.isAxiosError) {
    if (error.response) {
      console.log('axios response error');
      // todo handle 401
      // if (error.response.status === 401 && isAuthenticated) {
      //   window.location.reload();
      //   if (!errors[actionKey] || errors[actionKey]?.count <= 5) {
      //     setTimeout(() => {
      //       dispatch(currentAction);
      //     }, 1000);
      //   } else {
      //     auth0Client.logout();
      //   }
      // }
    }
    if (error.request) {
      console.log('axios request error');
    }
  } else {
    console.log('no axios error');
  }
});
